var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayPass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1937_23129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.142 1.28564C17.0228 4.5432 18.0129 8.23843 18.0129 11.9999C18.0129 15.7614 17.0228 19.4567 15.142 22.7142M10.4277 3.64279C11.8947 6.18368 12.667 9.06596 12.667 11.9999C12.667 14.9339 11.8947 17.8162 10.4277 20.3571M5.92773 5.80707C6.98848 7.66388 7.54691 9.77016 7.54691 11.9142C7.54691 14.0583 6.98848 16.1646 5.92773 18.0214M1.42773 8.14279C2.1922 9.29976 2.59749 10.6362 2.59749 11.9999C2.59749 13.3637 2.1922 14.7001 1.42773 15.8571",
    stroke: "white",
    strokeOpacity: 0.87,
    strokeWidth: 2.57143,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1937_23129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayPass);
export default __webpack_public_path__ + "static/media/payPass.f727a344016d53eb17192acfb8b35776.svg";
export { ForwardRef as ReactComponent };